import React, { CSSProperties } from 'react';
import { UseFormHandleSubmit, UseFormRegister } from 'react-hook-form';
import { BsArrowRepeat } from 'react-icons/bs';
import styled from 'styled-components';
import colors from 'theme/colors';
import { Button, Icon } from 'ui';
import Tooltip from 'components/ui/tooltip';

interface IProps {
  handleSendThreadsBotMessage: ({ message }: { message: string }) => Promise<void>;
  handleSubmit: UseFormHandleSubmit<{ message: string }>;
  register: UseFormRegister<{ message: string }>;
  isSending: boolean;
}

const SendButton = styled(Button)<{
  backgroundColor?: CSSProperties['backgroundColor'];
}>`
  transition: 0.2s ease;
  transform: scale(1);
  padding: 2px 15px;
  ${({ backgroundColor }) => backgroundColor}

  &:hover {
    transform: scale(1.1);
    background: ${colors.bgSlate50};
  }
`;

const ThreadsBotTextInput: React.FC<IProps> = ({
  handleSendThreadsBotMessage,
  handleSubmit,
  register,
  isSending,
}) => {
  const { ref: messageRegisterRef, onChange } = register('message');

  const handleKeyboardEvent = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSubmit(handleSendThreadsBotMessage)();
    }
  };

  return (
    <form onSubmit={handleSubmit(handleSendThreadsBotMessage)}>
      <div className="flex w-full items-center justify-between">
        <textarea
          autoComplete="off"
          ref={messageRegisterRef}
          name="message"
          placeholder="Message"
          onChange={onChange}
          onKeyDown={handleKeyboardEvent}
          className={`
            w-full max-w-[450px] resize-none
            overflow-auto whitespace-pre-wrap break-words rounded-lg border
            border-transparent bg-blue5 px-4 py-3
            text-sm leading-[21px]
            text-white focus:outline-none focus:ring-2
            focus:ring-blue disabled:bg-dark1
            disabled:text-grey1
          `}
        />
        <SendButton
          disabled={isSending}
          type="submit"
          backgroundColor={colors.blue5}
          variant="plain"
          data-cy="chat-edit-send-btn"
        >
          {isSending ? (
            <Tooltip side="left" content="ThreadsBot is thinking...">
              <BsArrowRepeat
                size={25}
                strokeWidth={0.7}
                color={colors.gray1}
                className="animate-spin"
              />
            </Tooltip>
          ) : (
            <Icon icon="SendIcon" stroke={colors.gray1} />
          )}
        </SendButton>
      </div>
    </form>
  );
};

export default ThreadsBotTextInput;
